import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import storage from 'redux-persist/lib/storage';

import addUserReducer from '../reducers/addUser';
import changePasswordReducer from '../reducers/changePassword';
import completeRegistrationReducer from '../reducers/completeRegistration';
import confirmPasswordReducer from '../reducers/confirmPassword';
import forgotPasswordReducer from '../reducers/forgotPassword';
import getAllCoverageScoreReducer from '../reducers/getAllCoverageScore';
import getAutocheckNMVTISReducer from '../reducers/getAutocheckNMVTISReport';
import getAutocheckVehicleHistoryReducer from '../reducers/getAutocheckVehicleHistory';
import getConfigReducer from '../reducers/getConfig';
import getCustomersReducer from '../reducers/getCustomers';
import getStateCountryReducer from '../reducers/getStateCountry';
import getCustomerWithLocationsReducer from '../reducers/getCustomerWithLocations';
import getPhysicalDamageReducer from '../reducers/getPhysicalDamage';
import getPersonReducer from '../reducers/getPerson';
import getRiskPredictorScoreReducer from '../reducers/getRiskPredictorScore';
import getUserLocationsReducer from '../reducers/getUserLocations';
import isVinValidReducer from '../reducers/isVinValid';

import loginReducer from '../reducers/login';
import updateUserReducer from '../reducers/updateUser';
import userReducer from '../reducers/users';
import verifyUserReducer from '../reducers/verifyUser';
import getPortfoliosReducer from '../reducers/VXC/getPortfolios';
import addEditCustomerReducer from './addEditCustomer';
import addEditCustomerGroupReducer from './addEditCustomerGroup';
import addEditLocationReducer from './addEditLocation';
import errorReducer from './errorReducer';
import getACAReportReducer from './getACAReport';
import getAccidentReportReducer from './getAccidentReport';
import getCanadianPlusReportReducer from './getCanadianPlusReport';
import getCanadianReportReducer from './getCanadianReport';
import getCompromisedReportReducer from './getCompromisedReport';
import getCustomerGroupsReducer from './getCustomerGroups';
import getDisasterReportReducer from './getDisasterReport';
import getDiscrepancyReportReducer from './getDiscrepancyReport';
import getExceptionReportReducer from './getExceptionReport';
import getHistoricalAnnouncementsReportReducer from './getHistoricalAnnouncementsReport';
import getMyActivityReducer from './getMyActivity';
import getPortfolioAlertsReducer from './getPortfolioAlerts';
import getPortfolioAuditReducer from './getPortfolioAudit';
import getRecallReportReducer from './getRecallReport';
import getReportTypesReducer from './getReportTypes';
import getRoutesReducer from './getRoutes';
import getTheftReportReducer from './getTheftReport';
import postCorrectionRequestReducer from './postCorrectionRequest';
import postCreatePresignedUrl from './postCreatePresignedUrl';
import postPresignedUrlReducer from './postPresignedUrl';
import postUploadFileToPresignedUrl from './postUploadFileToPresignedUrl';
import postUrlFileUploadReducer from './postUrlFileUpload';
import saveProductReducer from './saveProduct';
import searchReducer from './search';
import searchDataRetention from './searchDataRetention';
import storeAddressListReducer from './storeAddressList';
import managePortfoliosReducer from './VXC/managePortfolios';
import storeCustomerDataReducer from './VXC/storeCustomerData';
import storeInstitutionDataReducer from './VXC/storeInstitutionData';
import storePortfolioFormDataReducer from './VXC/storePortfolioFormData';

import getACAReportJsonData from './getACAReportJsonData';
import getMileageReportReducer from './getMileageReport';


const appReducers = combineReducers({
  mileageReport: getMileageReportReducer,
  acaReport: getACAReportReducer,
  accidentReport: getAccidentReportReducer,
  addEditLocation: addEditLocationReducer,
  addEditCustomerGroup: addEditCustomerGroupReducer,
  addEditCustomer: addEditCustomerReducer,
  addressList: storeAddressListReducer,
  addUser: addUserReducer,
  allCoverageScoreReport: getAllCoverageScoreReducer,
  autocheckVehicleHistoryReport: getAutocheckVehicleHistoryReducer,
  autocheckNMVTISReport: getAutocheckNMVTISReducer,
  canadianReport: getCanadianReportReducer,
  canadianPlusReport: getCanadianPlusReportReducer,
  changePassword: changePasswordReducer,
  compromisedReport: getCompromisedReportReducer,
  config: getConfigReducer,
  confirmPassword: confirmPasswordReducer,
  correctionRequest: postCorrectionRequestReducer,
  createPresignedUrl: postCreatePresignedUrl,
  customers: getCustomersReducer,
  customerGroups: getCustomerGroupsReducer,
  customerLocations: getCustomerWithLocationsReducer,
  currentProduct: saveProductReducer,
  customerData: storeCustomerDataReducer,
  discrepancyReport: getDiscrepancyReportReducer,
  disasterReport: getDisasterReportReducer,
  error: errorReducer,
  exceptionReport: getExceptionReportReducer,
  forgotPassword: forgotPasswordReducer,
  form: formReducer,
  historicalAnnouncement: getHistoricalAnnouncementsReportReducer,
  institutionData: storeInstitutionDataReducer,
  isVinValud: isVinValidReducer,
  login: loginReducer,
  managePortfolios: managePortfoliosReducer,
  myActivity: getMyActivityReducer,
  person: getPersonReducer,
  physicalDamageReport: getPhysicalDamageReducer,
  portfolioAlerts: getPortfolioAlertsReducer,
  portfolioAudit: getPortfolioAuditReducer,
  portfolioFormData: storePortfolioFormDataReducer,
  portfolios: getPortfoliosReducer,
  postPresignedUrl: postPresignedUrlReducer,
  postUrlFileUpload: postUrlFileUploadReducer,
  recallReport: getRecallReportReducer,
  registration: completeRegistrationReducer,
  reportTypes: getReportTypesReducer,
  riskPredictorScoreReport: getRiskPredictorScoreReducer,
  routes: getRoutesReducer,
  searchDataRetention,
  search: searchReducer,
  stateCountry: getStateCountryReducer,
  theftReport: getTheftReportReducer,
  updateUser: updateUserReducer,
  uploadFileToPresignedUrl: postUploadFileToPresignedUrl,
  userLocations: getUserLocationsReducer,
  users: userReducer,
  verify: verifyUserReducer,
  getACAReportJsonData
});

const reducers = (state, action) => {
  if (action.type === 'SIGNOUT_USER_FETCH_FULFILLED') {
    storage.removeItem('persist:root');
    // after signout, we clear the state for the login
    return { ...state, fetching: false, fetched: false, authenticated: false, login: {}, };
  }

  return appReducers(state, action);
};

export default reducers;


// WEBPACK FOOTER //
// ./src/reducers/index.js